import { render, staticRenderFns } from "./AxAppFailureJsonSettingsLoad.vue?vue&type=template&id=1fce1e96&scoped=true&"
import script from "./AxAppFailureJsonSettingsLoad.vue?vue&type=script&lang=ts&"
export * from "./AxAppFailureJsonSettingsLoad.vue?vue&type=script&lang=ts&"
import style0 from "./AxAppFailureJsonSettingsLoad.vue?vue&type=style&index=0&id=1fce1e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce1e96",
  null
  
)

export default component.exports